(function ($) {
  'use strict';

  if ($.fn.preventParentScroll) return;

  $.fn.preventParentScroll = function () {
    this.bind('mousewheel DOMMouseScroll', function (e) {
      const delta = e.originalEvent.wheelDelta || -e.originalEvent.detail;

      if (delta > 0 && $(this).scrollTop() <= 0)
        return false;

      return !(delta < 0 && (Math.ceil($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight));
    });
  };
})(jQuery);
